import React from "react";
import { Button, Grid, Link } from "@mui/material";
import iosButton from "../../assets/images/ios-button.svg";
import androidButton from "../../assets/images/android-button.svg";

const sxStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    justifyItems: "center",
    width: "355px",
    height: "56px",
    marginTop: "20px",
  },
};

const PlatformBox = () => {
  return (
    <Grid sx={sxStyles.mainContainer}>
      <Button
        sx={{
          "&.MuiButtonBase-root:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Link
          href={"https://apps.apple.com/us/app/bizarrapp/id6443452982"}
          target={"_blank"}
        >
          <img src={iosButton} />
        </Link>
      </Button>
      <Button
        sx={{
          "&.MuiButtonBase-root:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Link
          href={"https://play.google.com/store/apps/details?id=com.enigma.bzrp"}
          target={"_blank"}
        >
          <img src={androidButton} />
        </Link>
      </Button>
    </Grid>
  );
};

export default PlatformBox;
